import * as React from "react";
import { AppShell, Callout, FullWidthPage, Tabs, useMediaQuery } from "@wayflyer/flyui";
import type { DatePickerHeaderProps } from "@wayflyer/flyui-dataviz";
import { DatePickerHeader } from "@wayflyer/flyui-dataviz";

import { DataGroupContainer, Spinner } from "../components/styled";

import type { GenericAdsTabProps } from "./components/generic-ads-tab";
import { GenericAdsTab } from "./components/generic-ads-tab";

export interface GenericAdsProps {
  pageTitle: string;
  hint?: React.ReactNode;
  tabDataLoading?: boolean;
  tabDataError?: string;
  tabData: GenericAdsTabProps[];
  selectedTabIndex?: number;
  onSelectTab?: (title: string, tabIndex: number) => void;
  datePickerHeaderProps?: DatePickerHeaderProps;
}

/**
 * GenericAds component
 */
export const GenericAds = ({
  hint = "",
  pageTitle,
  tabData,
  tabDataLoading = false,
  tabDataError = "",
  selectedTabIndex = 0,
  onSelectTab = () => {},
  datePickerHeaderProps,
}: GenericAdsProps) => {
  const query = useMediaQuery();

  return (
    <AppShell>
      <FullWidthPage title={pageTitle}>
        {tabDataError ? <Callout variant="critical" description={tabDataError} /> : null}
        {!tabDataError ? (
          <DataGroupContainer>
            <DatePickerHeader
              summary={query("sm").windowGt && hint ? hint : ""}
              onChange={datePickerHeaderProps.onChange}
              currentPreset={datePickerHeaderProps.currentPreset}
              dateRangePresets={datePickerHeaderProps.dateRangePresets}
              startDate={datePickerHeaderProps.startDate}
              endDate={datePickerHeaderProps.endDate}
              useSimplePanel={true}
            />
            {tabDataLoading ? (
              <Spinner />
            ) : (
              <Tabs
                tabs={tabData.map((tabData) => {
                  return {
                    title: tabData.title,
                    content: <GenericAdsTab {...tabData} />,
                    disabled: false,
                  };
                })}
                selectedTabIndex={selectedTabIndex}
                onSelectTab={onSelectTab}
              />
            )}
          </DataGroupContainer>
        ) : null}
      </FullWidthPage>
    </AppShell>
  );
};
